<template>
  <div class="add_manage">
    <h2 style="font-size: 24px; ">添加管理员</h2>
    <div class="manage_con manage_flex">
      <div class="con_warp">
        <a-steps :current="current">
          <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>
        <div class="steps-content">
          <div v-if="current === 0">
            <div class="con_part manage_flex">
              <span class="title">身份证：</span>
              <a-input placeholder="请输入" v-model="accoutCard" />
              <span v-show="cardShow" style="color: #FA9D48; margin-left: 8px;">身份证有误，请核实</span>
            </div>
            <div class="con_part manage_flex">
              <span class="title">姓名：</span>
              <a-input placeholder="请输入" v-model="accoutName" />
            </div>
            <div class="con_part manage_flex">
              <span class="title">密码：</span>
              <span style="color: #8C8C8C;">默认为abc321，登录后可进行修改</span>
            </div>
            <div class="con_part manage_flex">
              <span class="title">联系方式（选填）：</span>
              <a-input placeholder="请输入手机号" v-model="accoutTel" />
            </div>
          </div>
          <div v-if="current === 1">
            <div>
              <div class="success_box">
                <img src="@/assets/complete_icon.png" alt="">
              </div>
              <p style="font-size: 16px; text-align: center; font-weight: bold;">操作成功</p>
              <div class="result_box manage_flex">
                <ul v-if="manageInfo" style="padding: 0px; margin: 0px;">
                  <li>
                    <span>账号：</span>
                    <span style="color: #646464;">{{manageInfo.user_name}}</span>
                  </li>
                  <li>
                    <span>密码：</span>
                    <span style="color: #646464;">abc321</span>
                  </li>
                  <li>
                    <span>姓名：</span>
                    <span style="color: #646464;">{{manageInfo.real_name}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="steps-action">
          <div v-if="current < steps.length - 1" class="action_next">
            <a-button type="primary" @click="next" :disabled="nextHand">下一步</a-button>
          </div>
          <div v-if="current > 0" class="action_prev">
            <a-button style="margin-left: 8px" @click="prev">返回</a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'AddManage',
  data () {
    return {
      current: 0,
      steps: [
        {
          title: '填写基本信息'
        },
        {
          title: '完成'
        }
      ],
      accoutCard: null,
      accoutName: null,
      accoutTel: null,
      cardShow: false,
      manageInfo: null
    }
  },
  computed: {
    ...mapState([
      'teacherAdmin',
      'isAddAccount'
    ]),
    nextHand () {
      if (this.accoutCard && this.accoutName) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    ...mapActions([
      'addAccount',
      'getTotalAccout'
    ]),
    async next () {
      let idCard = require('idcard')
      let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/
      const cardInfo = idCard.verify(this.accoutCard)
      if (cardInfo) {
        this.cardShow = false
        let result = {
          uid: this.teacherAdmin.uid,
          school_id: this.teacherAdmin.school_id,
          user_name: this.accoutCard,
          password: 'abc321',
          real_name: this.accoutName,
          role_id: 2
        }
        if (this.accoutTel) {
          if (myreg.test(this.accoutTel)) {
            result['phone_number'] = this.accoutTel
            await this.addAccount(result)
            if (this.isAddAccount) {
              this.current++
              await this.getTotalAccout()
            } else {
              this.$message.error('身份证号重复，添加管理员失败')
            }
          } else {
            this.$message.error('请核对您的手机号是否正确')
          }
        } else {
          await this.addAccount(result)
          if (this.isAddAccount) {
            this.current++
            await this.getTotalAccout()
          } else {
            this.$message.error('身份证号重复，添加管理员失败')
          }
        }
        this.manageInfo = result
      } else {
        this.cardShow = true
      }
    },
    prev () {
      this.$router.push('/userList/accountset')
    }
  }
}
</script>

<style>
.add_manage {
  width: 100%;
  color: #262626;
  font-size: 14px;
}
.add_manage .manage_flex {
  display: flex;
}
.add_manage .manage_con {
  margin-top: 24px;
  padding: 40px 0px;
  border: 1px solid #E8E8E8;
  background-color: #FFFFFF;
  box-sizing: border-box;
  justify-content: center;
}
.add_manage .manage_con .con_warp {
  width: 525px;
}
.add_manage .manage_con .con_part {
  align-items: center;
  margin-bottom: 16px;
}
.add_manage .manage_con .con_part:nth-child(2), .add_manage .manage_con .con_part:nth-child(3) {
  margin-bottom: 28px;
}
.add_manage .manage_con .con_part .ant-input {
  width: 250px;
  height: 38px;
}
.add_manage .manage_con .con_part .title {
  width: 130px;
  display: inline-block;
  text-align: right;
  margin-right: 8px;
}
.add_manage .manage_con .steps-content {
  margin-top: 40px;
}
.add_manage .manage_con .steps-action .action_next {
  margin-top: 40px;
  padding-left: 138px;
  box-sizing: border-box;
}
.add_manage .manage_con .steps-action .action_prev {
  text-align: center;
  margin-top: 32px;
}
.add_manage .manage_con .success_box {
  text-align: center;
  margin-bottom: 24px;
}
.add_manage .manage_con .result_box {
  width: 500px;
  padding: 24px 0px;
  margin-top: 24px;
  box-sizing: border-box;
  background-color: #F5F5F5;
  justify-content: center;
}
.add_manage .manage_con .result_box ul li {
  margin-bottom: 16px;
}
.add_manage .manage_con .result_box ul li:last-child {
  margin-bottom: 0px;
}
.add_manage .manage_con .ant-btn-primary, .add_manage .manage_con .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title::after {
  background-color: #51BF94;
}
.add_manage .manage_con .ant-btn-primary:hover, .add_manage .manage_con .ant-btn-primary:focus {
  color: #FFFFFF;
  background-color:rgba(81, 191, 148, .7);
}
.add_manage .manage_con .ant-btn-primary[disabled] {
  color: #FFFFFF;
  background-color: rgba(81, 191, 148, .5);
}
.add_manage .manage_con .ant-steps-item-process .ant-steps-item-icon {
  background-color: #51BF94;
  border-color: #51BF94;
}
.add_manage .manage_con .ant-steps-item-finish .ant-steps-item-icon {
  border-color: #51BF94;
}
.add_manage .manage_con .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: #51BF94;
}
</style>
